import React from 'react';
import { Cpu, ShoppingBag, HeartPulse, GraduationCap, Landmark, Users, UtensilsCrossed, Briefcase } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import SectionHeading from '@/components/site/SectionHeading';

const INDUSTRIES = [
  { icon: Cpu, label: 'IT & Technology' },
  { icon: ShoppingBag, label: 'Retail Brands' },
  { icon: HeartPulse, label: 'Healthcare' },
  { icon: GraduationCap, label: 'Education' },
  { icon: Landmark, label: 'Banking & Financial Services' },
  { icon: Users, label: 'Coworking Operators' },
  { icon: UtensilsCrossed, label: 'Food & Beverage' },
  { icon: Briefcase, label: 'Professional Services' },
];

export default function Industries() {
  return (
    <section data-testid="home-industries" className="py-20 md:py-28 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            kicker="Industries we serve"
            title="Trusted by occupiers across high-growth sectors."
            subtitle="From IT and BFSI to retail and healthcare — our occupier-side mandates and landlord-side leasing programs cover the sectors driving Hyderabad's commercial demand."
            align="center"
            className="text-center mx-auto"
          />
        </Reveal>
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.label} delay={i * 50}>
              <div className="group flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex h-11 w-11 items-center justify-center rounded-md bg-[#144726] text-[#C6A35B]">
                  <ind.icon className="h-5 w-5" />
                </div>
                <p className="text-sm font-semibold text-[#144726]">{ind.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
